module.exports = __webpack_public_path__ + "static/media/zoom-close.a1c732bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/zoom-close.svg
// module id = 2410
// module chunks = 0